import React from 'react';
import { Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import { toast } from 'react-toastify';
import Route from './routes';
import AppShell from './AppShell';
import SignInMed from '../pages/doctor/SignInMed';
import SignInMedExterno from '../pages/doctor/SignInMedExterno';
import SignInFunc from '../pages/funcionario/SignInFunc';
import SignInPac from '../pages/paciente/SignInPac';
import Tokenizer from '../pages/doctor/Tokenizer';
import FormMedico from '../pages/doctor/FormMedico';
import DashboardPac from '../pages/paciente/Dashboard';
import Laudos from '../pages/paciente/Atividade';
import AgendaPaciente from '../pages/paciente/AgendaPaciente';
import Agenda from '../pages/doctor/Agenda';
import Atividade from '../pages/doctor/Atividade';
import FormProntuario from '../pages/prontuario/FormProntuario';
import ReportDoppler from '../pages/laudo/eco/ReportDoppler';
import ReportCong from '../pages/laudo/eco/ReportCong';
import EspelhoDoppler from '../pages/laudo/eco/EspelhoDoppler';
import EspelhoCong from '../pages/laudo/eco/EspelhoCong';
import EspelhoCongTxt from '../pages/laudo/eco/EspelhoCongTXT';
import FormCongenitoTXT from '../pages/laudo/eco/FormCongenitoTXT';
import EspelhoTrans from '../pages/laudo/trans/EspelhoTrans';
import FormTrans from '../pages/laudo/trans/FormTrans';
import ReportTrans from '../pages/laudo/trans/ReportTrans';
import FormEcg from '../pages/laudo/ecg/FormEcg';
import EspelhoFisio from '../pages/laudo/stress/EspelhoFisio';
import EspelhoFarmaco from '../pages/laudo/stress/EspelhoFarmaco';
import FormStress from '../pages/laudo/stress/FormStress';
import ReportStress from '../pages/laudo/stress/ReportStress';
import ReportCarotida from '../pages/laudo/carotida/ReportCarotida';
import FormAvaliacao from '../pages/laudo/avaliacao/FormAvaliacao';
import ReportAvaliacao from '../pages/laudo/avaliacao/ReportAvaliacao';
import EspelhoCarotida from '../pages/laudo/carotida/EspelhoCarotida';
import FormCarotida from '../pages/laudo/carotida/FormCarotida';
import FormFetal from '../pages/laudo/fetal/FormFetal';
import EspelhoFetal from '../pages/laudo/fetal/EspelhoFetal';
import FormErgo from '../pages/laudo/ergo/FormErgo';
import ReportErgo from '../pages/laudo/ergo/ReportErgo';
import EspelhoErgo from '../pages/laudo/ergo/EspelhoErgo';
import { signOutPac } from '../store/modules/auth/patient/actions';
import { signOutMed } from '../store/modules/auth/doctor/actions';
import Index from '../pages/Login';
import ReportMapa from '../pages/laudo/mapa/ReportMapa';
import ReportHolter from '../pages/laudo/holter/ReportHolter';
import EspelhoMapa from '../pages/laudo/mapa/EspelhoMapa';
import EspelhoHolter from '../pages/laudo/holter/EspelhoHolter';
import ReportEcg from '../pages/laudo/ecg/ReportEcg';
import NotAllowed from '../components/NotAllowed';
import FormFechamento from '../pages/laudo/atividade/FormFechamento';
import FormAgendaDiaria from '../pages/laudo/atividade/FormAgendaDiaria';
import ValidaAtestado from '../pages/atestado/ValidaAtestado';
import ValidaRequisicao from '../pages/requisicao/ValidaRequisicao';
import ValidaReceita from '../pages/receita/ValidaReceita';
import ImagemCarotida from '../pages/laudo/carotida/ImagemCarotida';
import Agendamento from '../pages/paciente/Agendamento';
import FormEco from '../pages/laudo/eco/FormEco';
import FormEcoCongenito from '../pages/laudo/eco/FormEcoCongenito';
import Dicionarios from '../pages/admin/Dicionarios';
import AdminConvenios from '../pages/admin/Convenios';
import AdminProcedimentos from '../pages/admin/Procedimentos';
import AdminAtividades from '../pages/admin/Atividades';
import AdminFuncionarios from '../pages/admin/Funcionarios';
import RelatoriosFaturamento from '../pages/relatorios-faturamento/RelatoriosFaturamento';

// TODO JOAO: voltar a mexer nisso de lazy loading: carregar pro médico/paciente só o que/quando precisa
// const Dashboard = lazy(() => import('../components/evolution/Dashboard'));

// const DashboardWithSuspense = () => (
//   <Suspense fallback={<div>Carregando Painel WA...</div>}>
//     <Dashboard />
//   </Suspense>
// );

export default function Routes() {
  const dispatch = useDispatch();
  const signed = useSelector(state => state.patient.signed);
  const { profile, logged } = useSelector(state => state.doctor);
  const { logado } = useSelector(state => state.funcionario);

  // TODO: o certo é expirar a sessão no backend, não no frontend. onIdle nao invalida o token!
  function onIdle() {
    if (logged) {
      toast.success('Desconectando Médico!');
      dispatch(signOutMed());
    }
    if (signed) {
      toast.success('Desconectando Paciente!');
      dispatch(signOutPac());
    }
    if (logado) {
      toast.success('Desconectando Funcionário!');
      dispatch({ type: '@funcionario/SIGN_OUT' });
    }
  }

  let idleTimeout = 1000 * 60 * 60; // padrão: 1h
  if (logged) {
    if (profile?.tipo && profile.tipo.toUpperCase() !== 'AGENDA') {
      idleTimeout = 1000 * 60 * 5;
    } else {
      idleTimeout = 1000 * 60 * 60;
    }
  } else if (signed) {
    idleTimeout = 1000 * 60 * 5;
  } else if (logado) {
    idleTimeout = 1000 * 60 * 30;
  }

  return (
    <>
      <IdleTimer
        element={document}
        onIdle={onIdle}
        debounce={250}
        timeout={idleTimeout}
      />
      <AppShell>
        <Switch>
          <Route path="/" exact component={Index} />
          <Route path="/not-allowed" component={NotAllowed} />
          <Route path="/mlogin" component={SignInMed} />
          <Route path="/externo" component={SignInMedExterno} />
          <Route path="/plogin" component={SignInPac} />
          <Route path="/flogin" component={SignInFunc} />
          <Route path="/receita/validacao" component={ValidaReceita} />
          <Route path="/atestado/validacao" component={ValidaAtestado} />
          <Route path="/requisicao/validacao" component={ValidaRequisicao} />
          {signed ? (
            <Route
              path="/agendamento"
              component={Agendamento}
              isPrivate
              perfis={['paciente']}
            />
          ) : (
            <Route path="/agendamento" component={Agendamento} />
          )}

          <Route
            path="/tokenizer"
            component={Tokenizer}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/agenda"
            component={Agenda}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/frmatv"
            component={Atividade}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/form-medico"
            component={FormMedico}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/formProntuario"
            component={FormProntuario}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/reportMapa/:id"
            component={ReportMapa}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoMapa/:id"
            component={EspelhoMapa}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/reportHolter/:id"
            component={ReportHolter}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoHolter/:id"
            component={EspelhoHolter}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/formDoppler/:id"
            component={FormEco}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/reportDoppler/:id"
            component={ReportDoppler}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
            allowExternalDoctor
          />
          <Route
            path="/espelhoDoppler/:id"
            component={EspelhoDoppler}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoCong/:id"
            component={EspelhoCong}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoCongTxt/:id"
            component={EspelhoCongTxt}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/formCongenitoTXT/:id"
            component={FormCongenitoTXT}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/formCongenito/:id"
            component={FormEcoCongenito}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/formEcoCongenito/:id"
            component={FormEcoCongenito}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/reportEcoCongenito/:id"
            component={ReportCong}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
            allowExternalDoctor
          />
          <Route
            path="/formEcg/:id"
            component={FormEcg}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/reportEcg/:id"
            component={ReportEcg}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
          />
          <Route
            path="/espelhoTrans/:id"
            component={EspelhoTrans}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/form-trans/:id"
            component={FormTrans}
            isPrivate
            perfis={['medico', 'funcionario']}
            // allowExternalDoctor
          />
          <Route
            path="/report-trans/:id"
            component={ReportTrans}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/espelhoFisio"
            component={EspelhoFisio}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoFarmaco"
            component={EspelhoFarmaco}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/formStress"
            component={FormStress}
            isPrivate
            perfis={['medico', 'funcionario']}
            allowExternalDoctor
          />
          <Route
            path="/reportStress/:id"
            component={ReportStress}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
          />
          <Route
            path="/form-carotida/:id"
            component={FormCarotida}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/report-carotida/:id"
            component={ReportCarotida}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
          />
          <Route
            path="/espelhoCarotida"
            component={EspelhoCarotida}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/imagem-carotida/:id"
            component={ImagemCarotida}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/espelhoFetal"
            component={EspelhoFetal}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/form-fetal"
            component={FormFetal}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/formErgo/:id"
            component={FormErgo}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/reportErgo/:id"
            component={ReportErgo}
            isPrivate
            perfis={['medico', 'funcionario', 'paciente']}
          />
          <Route
            path="/espelhoErgo/:id"
            component={EspelhoErgo}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/paciente/inicio"
            component={DashboardPac}
            isPrivate
            perfis={['paciente']}
          />
          <Route
            path="/paciente/agendamentos"
            component={AgendaPaciente}
            isPrivate
            perfis={['paciente']}
          />
          <Route
            path="/paciente/exames"
            component={Laudos}
            isPrivate
            perfis={['paciente']}
          />
          <Route
            path="/form-avaliacao"
            component={FormAvaliacao}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/report-avaliacao/:id"
            component={ReportAvaliacao}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/fechamento"
            component={FormFechamento}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/relatorios-faturamento"
            component={RelatoriosFaturamento}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/agenda-diaria"
            component={FormAgendaDiaria}
            isPrivate
            perfis={['medico', 'funcionario']}
          />
          <Route
            path="/dicionarios"
            component={Dicionarios}
            isPrivate
            perfis={['medico', 'funcionario']}
            requireAdminFuncionario
          />
          <Route
            path="/admin/convenios"
            component={AdminConvenios}
            isPrivate
            perfis={['medico', 'funcionario']}
            requireAdminFuncionario
          />
          <Route
            path="/admin/procedimentos"
            component={AdminProcedimentos}
            isPrivate
            perfis={['medico', 'funcionario']}
            requireAdminFuncionario
          />
          <Route
            path="/admin/atividades"
            component={AdminAtividades}
            isPrivate
            perfis={['medico', 'funcionario']}
            requireAdminFuncionario
          />
          <Route
            path="/admin/funcionarios"
            component={AdminFuncionarios}
            isPrivate
            perfis={['medico', 'funcionario']}
            requireAdminFuncionario
          />
        </Switch>
      </AppShell>
    </>
  );
}
